import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './routes'

// Vuetify
import 'vuetify/styles'
//import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import { createPinia } from 'pinia'
import { createPostHog, usePostHog } from './plugins/posthog'

const vuetify = createVuetify({
  theme: {
    defaultTheme: localStorage.getItem('theme') === 'dark' ? 'dark' : 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#646cff',
          secondary: '#535bf2',
          background: '#f8fafc',
          surface: '#ffffff',
          error: '#ef4444',
          info: '#3b82f6',
          success: '#10b981',
          warning: '#f59e0b',
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: '#646cff',
          secondary: '#535bf2',
          background: '#0f172a',
          surface: '#1e293b',
          error: '#f87171',
          info: '#60a5fa',
          success: '#34d399',
          warning: '#fbbf24',
        },
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    global: {
      style: 'text-transform: none;',
    }
  }
});

const pinia = createPinia();

const app = createApp(App);

app.use(router);
app.use(vuetify);
app.use(pinia);

if (import.meta.env.VITE_APP_POSTHOG_KEY) {
  app.use(createPostHog(
    import.meta.env.VITE_APP_POSTHOG_KEY,
    import.meta.env.VITE_APP_POSTHOG_HOST ?? 'https://us.i.posthog.com',
  ));

  router.afterEach((to) => {
    usePostHog().capture('$pageview', { $current_url: to.fullPath });
  });
}

app.mount('#app');
